import PropTypes from 'prop-types';
import React from 'react';

var CheckmarkIcon = function CheckmarkIcon(_ref) {
  var size = _ref.size,
      fillColor = _ref.fillColor;
  return React.createElement("svg", {
    width: size,
    height: Math.ceil(size * 0.75),
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49993 2.41414C9.89045 2.02361 9.89045 1.39045 9.49992 0.999924C9.1094 0.6094 8.47623 0.6094 8.08571 0.999924L3.49992 5.58571L1.91414 3.99993C1.52361 3.6094 0.890449 3.6094 0.499924 3.99992C0.1094 4.39045 0.1094 5.02361 0.499924 5.41414L2.79282 7.70703C3.18334 8.09756 3.81651 8.09756 4.20703 7.70703L9.49993 2.41414Z",
    fill: fillColor
  }));
};

CheckmarkIcon.propTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.number
};
export default CheckmarkIcon;